import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20manga%20comic%20background%20with%20warm%20red%20and%20coral%20gradient%2C%20halftone%20dot%20patterns%2C%20ink%20splash%20textures%2C%20stylized%20comic%20panel%20lines%2C%20dark%20edges%2C%20dramatic%20atmospheric%20lighting%2C%20modern%20editorial%20design%2C%20rich%20texture%20with%20subtle%20paper%20grain%2C%20cinematic%20wide%20composition%2C%20warm%20amber%20and%20deep%20crimson%20tones&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="哔咔漫画网 - 免费漫画在线阅读平台"
          title="哔咔漫画网 - 免费漫画大全"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[40%] text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/20 text-background-50 text-sm mb-6">
              <i className="ri-sparkling-line"></i>
              <span>无需注册 · 完全免费 · 高清阅读</span>
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
              热门漫画
              <br />
              随时随地
              <span className="text-accent-400">在线畅读</span>
            </h1>
            <p className="text-lg text-background-50/80 mb-8 max-w-lg mx-auto lg:mx-0 leading-relaxed">
              收录国内外精品漫画，涵盖热血、玄幻、恋爱、科幻等多元题材。
              每日更新，高清画质，为你打造极致的漫画阅读体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/rexue"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap flex items-center gap-2"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/#ranking"
                className="px-8 py-3.5 rounded-full bg-background-50/10 text-background-50 border border-background-50/25 font-medium text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap"
              >
                查看排行榜
              </Link>
            </div>

            <div className="flex items-center gap-6 mt-8 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl font-bold text-background-50">12,000+</div>
                <div className="text-xs text-background-50/60 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-background-50">500万+</div>
                <div className="text-xs text-background-50/60 mt-1">活跃读者</div>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-background-50">每日更新</div>
                <div className="text-xs text-background-50/60 mt-1">从不间断</div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[60%] relative hidden lg:block">
            <div className="relative h-[500px] flex items-center justify-center">
              <div className="absolute right-0 top-0 w-44 h-60 rounded-xl overflow-hidden rotate-[-6deg] shadow-lg z-30 transform hover:rotate-0 hover:scale-110 transition-all duration-500 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%2C%20action%20hero%20in%20dynamic%20pose%20with%20glowing%20aura%2C%20clean%20white%20background%2C%20vibrant%20colors%2C%20bold%20linework%2C%20professional%20shonen%20manga%20style%2C%20striking%20visual%20impact&width=800&height=1100&seq=hero-float-01&orientation=portrait"
                  alt="一拳超人"
                  title="一拳超人 - 热门漫画推荐"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute right-20 top-32 w-40 h-56 rounded-xl overflow-hidden rotate-[3deg] shadow-lg z-20 transform hover:rotate-0 hover:scale-110 transition-all duration-500 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20art%2C%20demon%20slayer%20with%20water%20breathing%20effect%2C%20blue%20waves%2C%20dramatic%20composition%2C%20clean%20white%20background%2C%20professional%20manga%20style%20illustration%2C%20dynamic%20action&width=800&height=1100&seq=hero-float-02&orientation=portrait"
                  alt="鬼灭之刃"
                  title="鬼灭之刃 - 热门漫画推荐"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute right-40 top-64 w-36 h-52 rounded-xl overflow-hidden rotate-[-4deg] shadow-lg z-10 transform hover:rotate-0 hover:scale-110 transition-all duration-500 cursor-pointer">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%2C%20cultivation%20warrior%20in%20white%20robe%20with%20sword%2C%20misty%20mountain%20background%2C%20ink%20wash%20style%2C%20elegant%20traditional%20aesthetic%2C%20clean%20white%20background%2C%20professional%20illustration&width=800&height=1100&seq=hero-float-03&orientation=portrait"
                  alt="剑来"
                  title="剑来 - 热门漫画推荐"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-20"></div>
    </section>
  );
}